// extracted by mini-css-extract-plugin
export default {"moreButton":"_2-9Di","openButton":"ZwK-+","arrow":"ssJPE","arrowUp":"IYyiR","actionText":"weegN","preLabel":"nVxNz"};